class StickyAddToCart extends HTMLElement {
    constructor() {
        super();
        this.sticky = this;
        this.stickyBounds = document.getElementById('product-add-to-cart') || document.querySelector('[data-combo-addtocart]');
        this.closeSticky = this.querySelector('[data-close-sticky-add-to-cart]');
        this.expandSticky = this.querySelector('[data-expand-sticky-add-to-cart]');

        this.closeSticky?.addEventListener('click', this.setCloseSticky.bind(this));
        this.expandSticky?.addEventListener('click', this.setExpandSticky.bind(this));
            
        this.openStickyButton = document.getElementById('show-sticky-product');
        this.closeModal = this.closeStickyModal.bind(this);
    }

    connectedCallback() {
        // Eazy Eye: on mobile, hide this element entirely — we use our own bar
        if (window.innerWidth <= 767) {
            this.style.setProperty('display', 'none', 'important');
            this.style.setProperty('opacity', '0', 'important');
            this.style.setProperty('pointer-events', 'none', 'important');
            this.style.setProperty('visibility', 'hidden', 'important');
            return;
        }

        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.openStickyButton?.addEventListener('click', this.openStickyModal.bind(this));
        document.addEventListener('click', (e) => {
            if (e.target.matches('.background-overlay') || e.target.closest('[data-close-sticky-mobile]') != null || e.target.matches('[data-close-sticky-mobile]')) {
                this.closeModal();
            }
        })
    }

    openStickyModal() {
        document.body.classList.add('show-mobile-options');
        const height = this.closest('[data-sticky-add-to-cart]').clientHeight;
        this.sticky.querySelector('.sticky-product-mobile').style.bottom = height + 'px';
    }

    closeStickyModal() {
        document.body.classList.remove('show-mobile-options');
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        let offsetScroll;

        if (this.stickyBounds != null) {
            offsetScroll = $(this.stickyBounds).offset().top + $(this.stickyBounds).outerHeight(true) + 100;
        } else {
            offsetScroll = 0;
        }

        const winHeight = window.innerHeight;
        const docHeight = document.body.clientHeight;

        if (scrollTop > offsetScroll && scrollTop + winHeight < docHeight) {
            requestAnimationFrame(this.show.bind(this));

            if (this.sticky.classList.contains('style-1')) {
                let height = 0;
                const previewBar = document.getElementById('preview-bar-iframe'),
                    toolbarMobile = document.querySelector('.halo-sticky-toolbar-mobile');

                if (previewBar && window.getComputedStyle(previewBar).display !== "none") {
                    height = previewBar.offsetHeight;
                } else if (toolbarMobile) {
                    height = toolbarMobile.offsetHeight;
                }

                this.sticky.style.top = 'auto';
                this.sticky.style.bottom = `${height}px`;
                document.querySelector('.quick-order-list__total')?.style.setProperty('bottom', `${height + this.offsetHeight}px`);
            } else if (this.sticky.classList.contains('style-2')) {
                if (document.body.classList.contains('scroll-up')) {
                    let height = document.querySelector('sticky-header').offsetHeight;
                    if (window.innerWidth < 551) height = height + 20;
                    this.sticky.style.top = `${height}px`;
                } else if (document.body.classList.contains('scroll-down')) {
                    this.sticky.style.top = window.innerWidth > 550 ? 0 : '20px';
                }
            }
        } else {
            requestAnimationFrame(this.hide.bind(this));
            if (this.sticky.classList.contains('style-1')) document.querySelector('.quick-order-list__total')?.style.setProperty('bottom', '0px');
        }

        this.currentScrollTop = scrollTop;
    }

    hide() {
        this.sticky.classList.remove('show-sticky', 'hidden-sticky', 'full-sticky', 'animate');
        document.body.classList.remove('show-mobile-options');
    }

    show() {
        this.sticky.classList.add('show-sticky', 'animate');
    }

    setCloseSticky(event) {
        event.preventDefault();
        if (this.sticky.classList.contains('full-sticky')) {
            this.sticky.classList.remove('full-sticky');
        } else {
            this.sticky.classList.add('hidden-sticky');
        }
    }

    setExpandSticky(event) {
        event.preventDefault();
        this.sticky.classList.add('full-sticky');
    }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);

class VariantStickyAddToCart extends HTMLElement {
    constructor() {
        super();
        this.item = $(this).closest('.productView');
        this.sticky = $(this).closest('.productView-stickyCart');
        this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange(event) {
        this.updateOptions();   
        this.updateMasterId();
        this.updatePickupAvailability();
        this.updateMedia(200);
        this.updateURL();
        this.updateVariantInput();
        this.renderProductAjaxInfo();
        this.renderProductInfo();
        this.updateAttribute(!this.currentVariant.available);
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    decodeOptions() {
        this.options = this.options.map(option => this.decodeOption(option));
    }
    
    decodeOption(option) {
        if (option) return option.split('Special_Double_Quote').join('"').split('Special_Slash').join('/');
        return null;
    }

    encodeOption(option) {
        if (option) return option.split('"').join('Special_Double_Quote').split('/').join('Special_Slash');
        return null;
    }

    updateMasterId() {
        this.decodeOptions();
        this.currentVariant = this.getVariantData().find((variant) => variant.id == this.options);
    }

    updateMedia(time) {
        if (!this.currentVariant || !this.currentVariant?.featured_media) return;
        const itemImage = this.item.find('.sticky-image');
        const image = this.currentVariant?.featured_image;
        if (!itemImage) return;
        itemImage.find('img').attr({ 'src': image.src, 'srcset': image.src, 'alt': image.alt });
        const newMedia = document.querySelectorAll(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
        if (!newMedia) return;
        window.setTimeout(() => { $(newMedia).trigger('click'); }, time);
    }

    updateURL() {
        if (!this.currentVariant) return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.product}, #product-form-installment-${this.dataset.product}, #product-form-sticky-${this.dataset.product}`);
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;
        if (this.currentVariant?.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    renderProductAjaxInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const id = `product-price-${this.dataset.product}`;
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const destination = document.getElementById(id);
                const source = html.getElementById(id);
                if (source && destination) destination.innerHTML = source.innerHTML;
                document.getElementById(`product-price-${this.dataset.product}`)?.classList.remove('visibility-hidden');
            });
    }

    renderProductInfo() {
        var variantList = this.getVariantData().filter((variant) => variant.available);
        var selectedOption1 = this.currentVariant?.option1,
            selectedOption2 = this.currentVariant?.option2,
            selectedOption3 = this.currentVariant?.option3,
            options = this.item.find('.product-form__input:not(.mobile)'),
            optionsMobile = this.item.find('.product-form__input.mobile');

        const renderOptions = (options) => {
            $.each(options, (index, element) => {
                var position = $(element).data('option-index'),
                    type = $(element).data('product-attribute');
                switch (position) {
                    case 0:
                        $(element).find('[data-header-option]').text(selectedOption1);
                        if (type == 'set-select') {
                            $(element).find('.select__select').val(selectedOption1);
                        } else {
                            $(element).find('.product-form__radio').prop('checked', false);
                            $(element).find(`.product-form__radio[value="${this.encodeOption(selectedOption1)}"]`).prop('checked', true).trigger('change');
                        }
                        break;
                    case 1:
                        $(element).find('[data-header-option]').text(selectedOption2);
                        if (type == 'set-select') {
                            $(element).find('.select__select').val(selectedOption2);
                        } else {
                            $(element).find('.product-form__radio').prop('checked', false);
                            $(element).find(`.product-form__radio[value="${this.encodeOption(selectedOption2)}"]`).prop('checked', true).trigger('change');
                        }
                        break;
                    case 2:
                        $(element).find('[data-header-option]').text(selectedOption3);
                        if (type == 'set-select') {
                            $(element).find('.select__select').val(selectedOption3);
                        } else {
                            $(element).find('.product-form__radio').prop('checked', false);
                            $(element).find(`.product-form__radio[value="${this.encodeOption(selectedOption3)}"]`).prop('checked', true).trigger('change');
                        }
                        break;
                }
            });
        };

        renderOptions(options);
        renderOptions(optionsMobile);
    }

    updateAttribute(disable = true) {
        const addButton = document.getElementById(`product-form-${this.dataset.product}`)?.querySelector('[name="add"]');
        const stickyButton = document.getElementById(`product-form-sticky-${this.dataset.product}`)?.querySelector('[name="add"]');
        var quantityInput = $('[data-sticky-add-to-cart] .quantity__input'),
            notifyMe = this.item.find('.productView-notifyMe');

        if (disable) {
            var text = window.variantStrings.soldOut;
            this.item.removeClass('isChecked');
            quantityInput.attr('disabled', true);
            if (addButton) { addButton.setAttribute('disabled', true); addButton.textContent = text; }
            if (stickyButton) { stickyButton.setAttribute('disabled', true); stickyButton.textContent = text; }
            if (notifyMe.length > 0) { notifyMe.find('.halo-notify-product-variant').val(this.currentVariant.title); notifyMe.slideDown('slow'); }
        } else {
            var text = window.variantStrings.addToCart;
            this.item.addClass('isChecked');
            quantityInput.attr('disabled', false);
            if (addButton) { addButton.removeAttribute('disabled'); addButton.textContent = text; }
            if (stickyButton) { stickyButton.removeAttribute('disabled'); stickyButton.textContent = text; }
            // Update our Buy Now bar
            var buyNowBtn = document.getElementById('eb-btn');
            if (buyNowBtn && this.currentVariant) {
                buyNowBtn.href = '/cart/' + this.currentVariant.id + ':1?checkout';
            }
            var ebImg = document.getElementById('eb-img');
            if (ebImg && this.currentVariant?.featured_image?.src) {
                ebImg.src = this.currentVariant.featured_image.src;
            }
            if (notifyMe.length > 0) notifyMe.slideUp('slow');
        }
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    checkNeedToConvertCurrency() {
        var currencyItem = $('.dropdown-item[data-currency]');
        if (currencyItem.length) {
            return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
        }
    }
}

customElements.define('variant-sticky-selects', VariantStickyAddToCart);

class VariantStickyRadios extends VariantStickyAddToCart {
    constructor() { super(); }

    connectedCallback() { this.updateMediaTimeout = undefined; }

    onVariantChange(event) {
        this.updateOptions();
        this.updateMasterId();
        this.updatePickupAvailability();
        this.updateMedia(10);
        this.updateURL();
        this.updateVariantInput();
        this.updateSelectVariant();
        this.renderProductAjaxInfo();
        this.renderProductInfo();
        this.updateAttribute(!this.currentVariant.available);
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value);
    }

    decodeOptions() { this.options = this.options.map(option => this.decodeOption(option)); }
    decodeOption(option) { if (option) return option.split('Special_Double_Quote').join('"').split('Special_Slash').join('/'); return null; }
    encodeOption(option) { if (option) return option.split('"').join('Special_Double_Quote').split('/').join('Special_Slash'); return null; }

    updateSelectVariant() {
        const selectElement = this.closest('.productView-stickyCart')?.querySelector('select');
        if (selectElement) selectElement.value = this.currentVariant.id;
    }

    updateMasterId() {
        this.decodeOptions();
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => this.options[index] === option).includes(false);
        });
    }

    updateMedia(time) {
        if (!this.currentVariant || !this.currentVariant?.featured_media) return;
        const itemImage = this.item.find('.sticky-image');
        const image = this.currentVariant?.featured_image;
        if (!itemImage) return;
        itemImage.find('img').attr({ 'src': image.src, 'srcset': image.src, 'alt': image.alt });
        const newMedia = document.querySelectorAll(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
        if (!newMedia) return;
        clearTimeout(this.updateMediaTimeout);
        this.updateMediaTimeout = setTimeout(() => { $(newMedia).trigger('click'); }, time);
    }

    openStickyModal() { document.body.classList.add('show-mobile-options'); }
    closeStickyModal() { document.body.classList.remove('show-mobile-options'); }
}

customElements.define('variant-sticky-radios', VariantStickyRadios);

function parseDoubleQuote(option, isDecoding = true) {
    if (!option) return option;
    return isDecoding ? option.replace('"', 'spc_dbl_qte') : option.replace('spc_dbl_qte', '"');
}
